const appConfig = {
  // backend url (with slash at end)
  URL: 'https://plattenseeimmo.hu/',
  CONTACTEMAIL: 'info@whitewebdesign.hu',
  DEFAULTLANG: 'hu',
  LIMIT_ITEMS: 10,
};

export default appConfig;
